export default class BottomModalDisplayState {
    static Initial = 'bmds_initial';
    static Closed = 'bmds_closed';
    static Open = 'bmds_open';
}
